module.exports = __webpack_public_path__ + "img/Richard.90b13ca1.png";